import { render } from "./before.vue?vue&type=template&id=225ac47c&scoped=true"
import script from "./before.vue?vue&type=script&lang=js"
export * from "./before.vue?vue&type=script&lang=js"

import "./before.vue?vue&type=style&index=0&id=225ac47c&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225ac47c"]])

export default __exports__